import { postRequest, patchRequest, deleteRequest, formRequest } from "@react/helpers/fetch"

export const createReserve = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/reserves.json`, body: { reserve: body } })

export const updateReserve = (projectId, id, body) =>
  patchRequest({ url: `/projects/${projectId}/reserves/${id}.json`, body: { reserve: body } })

export const destroyReserve = (projectId, id) =>
  deleteRequest(`/projects/${projectId}/reserves/${id}.json`)

const transition = (action) => (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/reserves/${id}/${action}.json`, body: {} })

export const startReserve  = transition("start")
export const fixReserve    = transition("fix")
export const acceptReserve = transition("accept")
export const rejectReserve = transition("reject")
export const reopenReserve = transition("reopen")

export const uploadReservePhoto = (projectId, reserveId, file, caption, takenAt, phase) => {
  const form = new FormData()
  form.append("image", file)
  if (caption)  form.append("caption",  caption)
  if (takenAt)  form.append("taken_at", takenAt)
  if (phase)    form.append("phase",    phase)
  return formRequest({
    method: "POST",
    url:    `/projects/${projectId}/reserves/${reserveId}/photos.json`,
    form,
  })
}

export const destroyReservePhoto = (projectId, reserveId, id) =>
  deleteRequest(`/projects/${projectId}/reserves/${reserveId}/photos/${id}.json`)
